import {
  formEncode,
  getToken,
  handleResponse,
  nextFormDataApi,
  nextJsonApi,
} from '@/API/core';

const patients = {
  fetchPatientData: async (patientId?: string) => {
    let response = null;
    const token = await getToken();
    try {
      let query = `/patients`;
      response = await nextJsonApi.post(
        query,
        { patientId: patientId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default patients;
